import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { SystemIntro } from './components/SystemIntro';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VisualCoaching } from './components/VisualCoaching';
import { VolumesSection } from './components/VolumesSection';
import { gymSlides, insideSlides, sessionSlides } from './data/gallery';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
}
export function App({
  showTestimonials = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-zinc-700" data-id="element-0" data-mp="85bap1hsmn2g">
      <main data-id="element-1" data-mp="3gle7udba4tcj">
        <Hero data-id="element-2" data-mp="3gl4rlhg1e0k1" />
        <ProductGallery heading="See inside MMA Coach Ready" description="Real pages from the system — visual progressions, coaching sequences, decision maps, corrections, drills and ready-to-use session structures." caption="This is what “open and coach” actually looks like." slides={insideSlides} data-id="element-3" data-mp="3gklag2y7ng72" />
        {showTestimonials && <TestimonialsStrip data-id="element-4" data-mp="2xuwsrbjddw9n" />}
        <PainPoints data-id="element-5" data-mp="2xu3ii0l7comr" />
        <SystemIntro data-id="element-6" data-mp="2xtlnt8e6uigy" />
        <SolutionReveal data-id="element-7" data-mp="2xssh27f8bsyt" />
        <VolumesSection data-id="element-8" data-mp="2svtr812lm86f" />
        <VisualCoaching data-id="element-9" data-mp="2swljp30wfpsh" />
        <ProductGallery heading="A system you can actually use in the gym" caption="Visual coaching pages designed for fast understanding, practical setup and immediate application." slides={gymSlides} tone="gray" data-id="element-10" data-mp="2svagp5fa2m2f" />
        <BonusSection data-id="element-11" data-mp="yg3kctsxvlpu" />
        <PricingSection data-id="element-12" data-mp="ygwkhbxe7cz0" />
        <ClosingArgument data-id="element-13" data-mp="ydii43oqb3rk" />
        <ProductGallery heading="From technique to complete session" caption="A visual coaching system built to help coaches move from individual skills to complete MMA development." slides={sessionSlides} data-id="element-14" data-mp="13eofietc3f7f" />
        <Guarantee data-id="element-15" data-mp="1w211onvl1l07" />
        <FAQ data-id="element-16" data-mp="1w2kgvwtulvaj" />
        <FinalCTA data-id="element-17" data-mp="1w0zp2eyx4qgd" />
      </main>
      <Footer data-id="element-18" data-mp="1i441lhhx6wgs" />
      <noscript data-id="element-19" data-mp="1i2j71rvlvdix">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-20" data-mp="1i31ab8goqs0c" />
      </noscript>
    </div>;
}